
const digest = '9e898e6527e8cb52d95745fd1b1bc79cb91077edd24b9431574e7706cc4a1070';
const classes = {"wrapper":"_wrapper_1vbe8_1","imageWrapper":"_imageWrapper_1vbe8_8","checkbox":"_checkbox_1vbe8_16","name":"_name_1vbe8_27"};
const css = `._wrapper_1vbe8_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
}
._wrapper_1vbe8_1 ._imageWrapper_1vbe8_8 {
  border-radius: 15px;
  width: 100%;
  aspect-ratio: 1.414/1;
  border: 1px solid #EAEDF4;
  padding: 12px;
  position: relative;
}
._wrapper_1vbe8_1 ._imageWrapper_1vbe8_8 ._checkbox_1vbe8_16 {
  position: absolute;
  right: 4px;
  top: 4px;
}
._wrapper_1vbe8_1 ._imageWrapper_1vbe8_8 img {
  width: 100%;
  max-height: 100%;
  object-fit: cover;
  cursor: pointer;
}
._wrapper_1vbe8_1 ._name_1vbe8_27 {
  text-align: center;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  